export const podcastResources = {

    "sharing-rss": {
        name: "Sharing Podcast",
        endpoint: "/api/podcast/episodes/sharing-rss"
    },

    "feliz-lltw-rss": {
        name: "Feliz Love & Light",
        endpoint: "/api/podcast/episodes/feliz-lltw-rss"
    }

};